import { combineReducers } from '@reduxjs/toolkit';

import brandSlice from 'entities/Brand/model/brandSlice';
import postSlice from 'entities/Post/model/postSlice';
import { baseApi } from 'shared/api/baseApi';
import commonSlice from 'shared/model/commonSlice';

export const rootReducer = combineReducers({
	brandSlice,
	commonSlice,
	postSlice,
	[baseApi.reducerPath]: baseApi.reducer,
});
